export default __webpack_public_path__ + "static/media/award03.3f7ee934.png";